import * as React from 'react';

const SvgLogOut = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox={'0 0 20 10'}
    {...props}
  >
    <path
      fill={'currentColor'}
      d='M5 10h10a5 5 0 0 0 0-10H5a5 5 0 0 0 0 10Zm0-7a2 2 0 1 1-2 2 2 2 0 0 1 2-2Z'
    />
  </svg>
);
export default SvgLogOut;
